import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation, inject } from '@angular/core';
import { Router } from '@angular/router';

import { EnvironmentConfig } from '../../client-config/index';
import { PubSubService } from '../../core/services/communication/pubsub/pubsub.service';
import { DeviceService } from '../../core/services/device/device.service';
import { GtmService } from '../../core/services/gtm/gtm.service';
import { UserService } from '../../core/services/user/user.service';
import { WindowRefService } from '../../core/services/windowRef/window-ref.service';
import { RendererService } from '../../shared/services/renderer/renderer.service';
import { AccaInsuranceCmsService } from './acca-insurance-cms.service';
import { IAccaIns } from './acca-insurance.model';

@Component({
    selector: 'acca-insurance',
    templateUrl: 'acca-insurance.component.html',
    styleUrls: ['acca-insurance.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [CommonModule],
})
export class AccaInsuranceComponent implements OnInit, OnChanges {
    accaCms: IAccaIns;
    issvgFirst: any;
    isCoral: boolean;
    isDesktop: boolean;
    mWidth: number = 46;
    dWidth: number = 109;
    isLoggedIn: boolean;
    @Input() templateType?: string = 'SP';
    @Input() isbsFloater?: boolean = false;
    @Input() upSellData?: any[] = [];
    @Input() id: any;
    @Input() variation?: number;
    @Input() progressBar?: any;
    @Input() spStatus?: boolean = false;
    @Input() isBsOpened?: boolean = false;
    @Input() isQuacca?: boolean = false;
    @Output() loaded = new EventEmitter<boolean>();
    private readonly environment = inject(EnvironmentConfig).configuration;

    constructor(
        private accaInsuranceCmsService: AccaInsuranceCmsService,
        private deviceService: DeviceService,
        protected windowRef: WindowRefService,
        private rendererService: RendererService,
        private gtmService: GtmService,
        protected router: Router,
        private userService: UserService,
        private pubSubService: PubSubService,
    ) {}

    ngOnInit() {
        this.isDesktop = this.deviceService.isDesktop;
        this.isCoral = this.environment.BRAND === 'bma';
        this.isLoggedIn = this.userService.status;
        this.isLoggedIn &&
            this.accaInsuranceCmsService.getAccaInsuranceConfig().subscribe((data) => {
                this.issvgFirst = /^\{.*?}/.test(data?.mybetsSp.mbsp); //checks {icn} place
                this.accaCms = data;
                this.spStatus && this.loaded.emit(this.accaCms?.enabled);
                this.pubSubService.publishSync(this.pubSubService.API.ACCA_INS, this.accaCms);
            });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.upSellData?.currentValue && changes.upSellData.currentValue.length) {
            const totalFill = changes.upSellData.currentValue.filter((i: { filled: boolean }) => i.filled).length;
            this.isbsFloater && !this.isBsOpened && this.sendGtmData('contentView', 'load', `acca boost - ${totalFill}`, 'upsell');
        }
    }

    /**
     * CMS configs to check the condition of my bets and bet receipt
     * @param type { string }
     * @returns { boolean }
     */
    showSP(type: string, upsell?: any) {
        return this.filterType(this.accaCms, type, upsell);
    }

    /**
     * filter type of event and removes class when SP is disabled
     * @param data { object }
     * @param type { string }
     * @returns
     */
    filterType(data: IAccaIns, type: string, upsell?: any) {
        // First, check if type exists and if it's an object that matches one of the expected structures

        if (type === 'mybetsSp' && !(data && data[type].enabled)) {
            const el = this.windowRef.document.querySelector(`.acca-insurance`);
            if (el) {
                this.rendererService.renderer.removeClass(el, 'acca-insurance');
            }
        }
        const typeData = data[type as keyof typeof data];
        if (upsell && typeData[upsell as keyof typeof typeData] === false) {
            return false;
        }
        return data && (typeData as keyof typeof data.enabled);
    }

    /**
     * gets acca insurance signpost and qualify message text
     * @returns string
     */
    getTxt(data: string) {
        return data.replace(/{.*?}\s*/, '');
    }

    /**
     * navigate to target url
     */
    onClick() {
        this.router.navigateByUrl(`/${this.accaCms?.profitIndiUrl}`);
        this.sendGtmData('Event.Tracking', 'click', 'acca insurance - qualified', 'myBets');
    }

    /**
     * triggers to send GA tracking data
     * @param eventType { string }
     */
    public sendGtmData(eventType: string, ActionEvent: string, EventDetails: string, type: string) {
        const location = type === 'myBets' ? 'my bets-settled' : 'betslip bar';
        this.gtmService.push(eventType, {
            'component.CategoryEvent': 'bets boost',
            'component.LabelEvent': 'acca boost',
            'component.ActionEvent': ActionEvent,
            'component.PositionEvent': 'not applicable',
            'component.LocationEvent': location,
            'component.EventDetails': EventDetails,
            'component.URLClicked': 'not applicable',
        });
    }

    /*
     * calculate width of the li items dynamically.
     */
    calculateWidth() {
        const len = 2 * (this.upSellData ? this.upSellData.length - 1 : 0);
        const elWidth = this.isDesktop ? this.dWidth - len : this.mWidth - len;
        const width = this.upSellData ? elWidth / this.upSellData.length : 0;
        return `${width}px`;
    }
}
